// extracted by mini-css-extract-plugin
export default {"root":"DiagnosticPackageTableRowGroup_root__HFScz","highlighted":"DiagnosticPackageTableRowGroup_highlighted__oQvMg"};